// src/extenders/language-switcher.js
var LanguageSwitcher = class extends HTMLElement {
  /**
   * Initialize the language switcher component and set up event listeners
   * @constructor
   */
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.dropdown = this.querySelector("[data-language-selector-list]");
    this.languageOptions = this.querySelectorAll("[data-language-selector-option]");
    this.form = this.querySelector("form");
    this.localeInput = this.querySelector('[name="locale_code"]');
    this.isOpen = false;
    this.button.addEventListener("click", this.toggleDropdown.bind(this));
    this.button.addEventListener("keydown", this.handleButtonKeydown.bind(this));
    document.addEventListener("click", (event) => {
      if (!this.contains(event.target) && this.isOpen) {
        this.closeDropdown();
      }
    });
    this.dropdown.addEventListener("keydown", this.handleDropdownKeydown.bind(this));
    this.languageOptions.forEach((option) => {
      option.addEventListener("click", this.handleLanguageSelect.bind(this));
    });
  }
  /**
   * Toggle the dropdown's visibility state
   * @private
   */
  toggleDropdown() {
    this.isOpen ? this.closeDropdown() : this.openDropdown();
  }
  /**
   * Open the dropdown and set appropriate ARIA attributes
   * @private
   */
  openDropdown() {
    this.isOpen = true;
    this.dropdown.classList.remove("hidden");
    this.button.setAttribute("aria-expanded", "true");
  }
  /**
   * Close the dropdown and reset ARIA attributes
   * @private
   */
  closeDropdown() {
    this.isOpen = false;
    this.dropdown.classList.add("hidden");
    this.button.setAttribute("aria-expanded", "false");
  }
  /**
   * Handle language selection and form submission
   * @private
   * @param {MouseEvent|KeyboardEvent} event - The event that triggered the selection
   */
  handleLanguageSelect(event) {
    const button = event.currentTarget;
    const newLocale = button.dataset.value;
    if (newLocale !== this.localeInput.value) {
      this.localeInput.value = newLocale;
      this.form.submit();
    }
    this.closeDropdown();
  }
  /**
   * Handle keyboard events on the trigger button
   * @private
   * @param {KeyboardEvent} event - The keyboard event
   */
  handleButtonKeydown(event) {
    var _a;
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        this.openDropdown();
        (_a = this.languageOptions[0]) == null ? void 0 : _a.focus();
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        this.openDropdown();
        break;
      case "Escape":
        if (this.isOpen) {
          event.preventDefault();
          this.closeDropdown();
          this.button.focus();
        }
        break;
    }
  }
  /**
   * Handle keyboard navigation within the dropdown
   * @private
   * @param {KeyboardEvent} event - The keyboard event
   */
  handleDropdownKeydown(event) {
    const currentIndex = Array.from(this.languageOptions).indexOf(document.activeElement);
    let nextIndex;
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        nextIndex = currentIndex + 1;
        if (nextIndex >= this.languageOptions.length)
          nextIndex = 0;
        this.languageOptions[nextIndex].focus();
        break;
      case "ArrowUp":
        event.preventDefault();
        nextIndex = currentIndex - 1;
        if (nextIndex < 0)
          nextIndex = this.languageOptions.length - 1;
        this.languageOptions[nextIndex].focus();
        break;
      case "Home":
        event.preventDefault();
        this.languageOptions[0].focus();
        break;
      case "End":
        event.preventDefault();
        this.languageOptions[this.languageOptions.length - 1].focus();
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        if (document.activeElement.hasAttribute("data-language-selector-option")) {
          this.handleLanguageSelect({ currentTarget: document.activeElement });
        }
        break;
      case "Escape":
        event.preventDefault();
        this.closeDropdown();
        this.button.focus();
        break;
      case "Tab":
        if (!event.shiftKey && currentIndex === this.languageOptions.length - 1) {
          this.closeDropdown();
        } else if (event.shiftKey && currentIndex === 0) {
          this.closeDropdown();
        }
        break;
    }
  }
};
customElements.define("language-switcher", LanguageSwitcher);
